var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('genre-list',{staticClass:"area-genres",attrs:{"allGenresSelected":_vm.allAreasSelected,"genreList":_vm.areas,"isGenreSelected":_vm.isAreaSelected},on:{"allGenresToggled":_vm.allAreasToggled,"genreToggled":_vm.areaToggled}})}
var staticRenderFns = []

export { render, staticRenderFns }